import { theme } from "@src/theme";
import React from "react";

type MusicNoteSVGProps = {
  $size: number;
  $active?: boolean;
};
const MusicNoteSVG: React.FC<MusicNoteSVGProps> = ({
  $size,
  $active = false,
}) => (
  <svg
    width={$size}
    height={$size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.9187 0.00700555L6.01875 1.35421C5.11875 1.44543 4.5 2.25235 4.5 3.15049V12.3845C4.08516 12.3108 3.63516 12.3108 3.15 12.4125C1.44141 12.8616 0 14.3667 0 15.8928C0 17.419 1.44141 18.3346 3.15 17.8856C4.85859 17.4365 6.3 15.9033 6.3 14.3772V6.65884L16.2 5.3397V11.4302C15.7852 11.3565 15.3352 11.3881 14.85 11.5144C13.1414 11.9635 11.7 13.4685 11.7 14.9947C11.7 16.5208 13.1414 17.4365 14.85 16.9874C16.5586 16.5384 18 15.0052 18 13.4791V1.80328C18 0.726217 16.998 -0.0842111 15.9187 0.00700555Z"
      fill={$active ? theme.colors.yellow : theme.colors.black}
    />
  </svg>
);

export default MusicNoteSVG;
